import type { Messages } from "@prop/i18n";
import type en from "../en/wallet";

export default {
  nav: "Баланс",
  chip: "Баланс: {amount}",
  page: {
    title: "Баланс",
    lead: "Пополните криптой, затем оплачивайте челленджи, сбросы и активации в одно касание.",
    available: "Доступно",
    topupTitle: "Пополнить",
    amount: "Сумма, USD",
    amountHint: "От {min} до {max}",
    start: "Пополнить на {amount}",
    noCrypto: "Пополнение сейчас недоступно. Напишите в поддержку.",
    history: "История",
    empty: "Пока ничего. Пополните баланс, чтобы оплатить челлендж с него.",
    continue: "Продолжить покупку",
    credited: "Зачислено {amount}. Баланс готов к оплате.",
    open: "Ждёт оплаты",
    another: "Новое пополнение",
    pay: "Оплатить",
    money: "Деньги",
    moneyHint: "То, что вы внесли или получили обратно. Можно вывести.",
    bonus: "Бонус",
    bonusHint: "Подарок команды: оплачивает челленджи и сборы, вывести нельзя. Тратится после денег.",
    bonusBurns: "{amount} сгорит {at}",
    frozen: "Ваш баланс заморожен: проверка личности показала страну, которую мы не обслуживаем. Напишите в поддержку.",
  },
  moves: {
    topup: "Пополнение",
    purchase: "Покупка",
    refund: "Возврат",
    adjustment: "Поправка команды",
    overpay: "Переплата по заказу",
    bonus: "Бонус от команды",
    bonus_expired: "Бонус сгорел",
    withdrawal: "Вывод",
    withdrawal_released: "Вывод возвращён",
  },
  status: { awaiting_payment: "ждёт оплаты", paid: "зачислено", expired: "окно закрыто", manual_review: "на проверке", canceled: "отменено" },
  pay: {
    method: "Баланс",
    fromBalance: "Оплатить с баланса",
    have: "На балансе {amount}",
    short: "Не хватает {short}",
    topupAndPay: "Пополнить на {amount} и оплатить",
    feeTitle: "Оплатить {amount}",
    feeLead: "Оплатите с баланса в одно касание или отправьте крипту: действие выполнится само, когда платёж придёт.",
    feeFromBalance: "Оплатить {amount} с баланса",
    feeCrypto: "Оплатить криптой",
    feeTopup: "Пополнить баланс",
    feeWaiting: "Ждём платёж — страница обновится сама.",
    feeDone: "Оплачено. Готово.",
    feeKept: "Платёж пришёл, но действие уже не выполнить. Деньги — на вашем балансе.",
    feeStart: "Показать адрес",
  },
  withdraw: {
    title: "Вывести",
    lead: "Деньги с баланса уходят на один из ваших кошельков для выплат. Команда проверяет каждую заявку и отправляет вручную.",
    amount: "Сумма, USD",
    min: "От {min} до {max}",
    to: "Куда",
    fee: "Комиссия сети",
    net: "Вы получите",
    confirm: "Вывести {amount}",
    sent: "Заявка принята. Сумма удерживается на балансе, пока команда её не отправит.",
    needKyc: "Для вывода нужна одобренная проверка личности.",
    goKyc: "Пройти проверку",
    needWallet: "Сначала добавьте кошелёк для выплат. Новым адресом можно пользоваться после срока ожидания.",
    goWallet: "Кошельки для выплат",
    belowMin: "Минимальный вывод — {min}. Ваши деньги: {money}.",
    restricted: "Вывод недоступен для вашей страны проживания. Напишите в поддержку.",
    history: "Выводы",
    status: { requested: "ждёт", prepared: "на проверке", paid: "отправлен", rejected: "отклонён" },
    refund: "Возврат на ваш кошелёк",
  },
  errors: {
    insufficient_balance: "На балансе не хватает средств.",
    topups_open: "У вас уже три открытых пополнения. Оплатите одно из них или дождитесь, пока закроется его окно.",
    topup_amount: "Пополнение — от {min} до {max}.",
    rail_busy: "Эта сеть сейчас занята. Выберите другую монету.",
    pay_from_balance: "Баланса хватает — оплатите с баланса.",
    payments_not_live: "Пополнение сейчас недоступно.",
    withdrawal_min: "Вывод — от {min}.",
    withdrawal_open: "У вас уже есть заявка на вывод. Дождитесь решения команды.",
    kyc: "Для вывода нужна одобренная проверка личности.",
    restricted_country: "Недоступно для вашей страны проживания.",
    wallet_not_ready: "Этот кошелёк пока нельзя использовать: он новый или не прошёл проверку.",
    balance_frozen: "Ваш баланс заморожен. Напишите в поддержку.",
  },
  admin: {
    tab: "Балансы",
    lead: "Балансы трейдеров, их движения и поправки. Поправку подтверждает второй человек.",
    search: "E-mail, имя или id пользователя",
    find: "Найти",
    user: "Трейдер",
    balance: "Баланс",
    requested: "Ждут подтверждения",
    none: "Здесь пусто.",
    amount: "Сумма (+ зачислить, − списать)",
    reason: "Причина (что случилось, номер тикета)",
    ask: "Запросить поправку",
    asked: "Запрошено. Подтверждает другой сотрудник.",
    credit: "Зачислить сейчас",
    credited: "Зачислено: баланс обновлён.",
    approve: "Подтвердить",
    reject: "Отклонить",
    rejectReason: "Почему отклонено",
    moves: "Движения",
    adjustments: "Поправки",
    by: "запросил {name}",
    close: "Закрыть",
    pot: "Часть баланса",
    potMoney: "Деньги — можно вывести",
    potBonus: "Бонус — сгорит через 7 дней",
    money: "Деньги",
    bonus: "Бонус",
    restricted: { sanctioned: "Санкционная страна: баланс заморожен", us: "Резидент США: без выплат и выводов" },
    usRefund: {
      title: "Возврат резиденту США",
      lead: "Возвращает каждую покупку на деньги (и сборы, бонус сгорает), закрывает все счета и удерживает все деньги для отправки на кошелёк. Дальше — как любой вывод.",
      wallet: "Кошелёк",
      run: "Вернуть и закрыть счета",
      done: "Готово: {amount} удержано для отправки на кошелёк.",
      noWallet: "Нет готового кошелька: человек должен добавить его (новый адрес ждёт свой срок).",
    },
    withdrawals: {
      title: "Выводы",
      lead: "Отправьте вручную с кошелька владельца, затем подтвердите с хешем транзакции. Кто подготовил — не подтверждает.",
      prepare: "Подготовить",
      approve: "Отправлено — подтвердить",
      reject: "Отклонить",
      rejectReason: "Отклонено при проверке",
      txHash: "Хеш транзакции",
      ownPrepared: "Подготовлено вами: подтверждает другой",
      net: "к получению {amount}",
      none: "Выводов нет.",
    },
    kind: { topup: "Пополнение баланса", fee: "Оплата сбора" },
    status: { requested: "ждёт", approved: "подтверждена", rejected: "отклонена" },
  },
} satisfies Messages<typeof en>;
